module.exports = __webpack_public_path__ + "static/media/Follower_Button-24.19832f39.png";